import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

dayjs.extend(utc);

const useStyles = makeStyles(() => ({
	alertaGlobal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		backgroundColor: "#4056C7",
		zIndex: 10000,
		padding: "6px 16px",
		borderBottomLeftRadius: "4px",
		borderBottomRightRadius: "4px",
	},
	containerTexto: {
		display: "flex",
		alignItems: "center",
		gap: "12px",
		color: "#FFFFFF",
	},
	texto: {
		color: "#FFFFFF",
	},
	botao: {
		color: "#FFFFFF",
		fontWeight: 500,
	},
}));

const AlertaGlobalPreVenda = () => {
	const classes = useStyles();
	const history = useHistory();

	// Obtém os grids de pedidos e o pedido detalhado atual do estado do Redux
	const { grids, order } = useSelector((state) => state.orders);

	// Busca se existe pelo menos um pedido de pré-venda em qualquer um dos grids carregados no Redux
	const orderPreVendaFromGrids = Object.values(grids || {})
		.flatMap((grid) => grid?.rows || [])
		.find((o) => o?.preVenda === true);

	// Define qual pedido usaremos como referência (prioriza o pedido detalhado ativo se for pré-venda, senão usa o das listagens)
	const targetOrder = order?.preVenda ? order : orderPreVendaFromGrids;

	// Se não houver pedido de pré-venda OU se hoje não for véspera do lançamento (exatamente 1 dia antes), não exibe o alerta
	if (
		!targetOrder ||
		dayjs
			.utc(targetOrder.dhEntregaEstimada)
			.startOf("day")
			.diff(dayjs.utc().startOf("day"), "day") !== 1
	) {
		return null;
	}

	const dataLancamento = targetOrder.dhEntregaEstimada
		? dayjs.utc(targetOrder.dhEntregaEstimada).format("DD/MM/YYYY")
		: "00/00/00";

	return (
		<Box className={`${classes.alertaGlobal} alerta-global-pre-venda`}>
			<Box className={classes.containerTexto}>
				<ErrorOutlineIcon />
				<Typography variant="body2" className={classes.texto}>
					<strong>Amanhã é dia de lançamento!</strong> É ideal separar os
					pedidos de pré-venda hoje e amanhã, {dataLancamento}, confirme o
					estoque e deixe tudo pronto para retirada.
				</Typography>
			</Box>
			<Button
				className={classes.botao}
				onClick={() => history.push("/new-orders")}
			>
				Novos Pedidos
			</Button>
		</Box>
	);
};

export default AlertaGlobalPreVenda;
